export default "__VITE_ASSET__47c6f741__"